import type { ProductData } from "@/mocks/products";

interface Props {
  product: ProductData;
}

export default function FeaturesSection({ product }: Props) {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Key Features
            </h2>
            <p className="text-base text-silver-400">
              Everything you need to run {product.name} effectively.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {product.features.map((feature, idx) => (
              <div
                key={feature.title}
                className="glass-card p-6 md:p-7 flex gap-4 group"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-graphite-800 border border-graphite-700 shrink-0 group-hover:bg-emerald-accent/10 transition-colors">
                  <i className={`${feature.icon} text-lg text-emerald-accent`} />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-white mb-1 group-hover:text-emerald-soft transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-silver-400 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}